import { useMutation } from '@tanstack/react-query';
import { OIDCAuthenticationClient } from '../httpClients/OIDCAuthenticationClient';
import { MUTATION_KEYS } from './consts';

type ConfirmDeviceCodeVariables = {
  sessionId: string;
  userCode: string;
};

/**
 * Confirms a CLI device-login code so the waiting CLI's poll releases credentials.
 * Loading/error state comes from the mutation (isPending/error); callers don't track it manually.
 */
export const useConfirmDeviceCodeMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.CONFIRM_DEVICE_CODE],
    mutationFn: ({ sessionId, userCode }: ConfirmDeviceCodeVariables) =>
      OIDCAuthenticationClient.confirmDeviceCode(sessionId, userCode),
  });
